'use client';
import React from "react"
import { useState } from 'react';
import H2HItem from '../H2HItem';
import HeaderTopRecentMatches from "@/components/server/HeaderTopRecentMatches";

function TabPanel({ home, away, data }) {
  const [activeTab, setActiveTab] = useState('first');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="rounded w-full mx-auto mt-4">
      <ul id="tabs" className="inline-flex pt-2 px-1 w-full border-b mb-4">
        <li
          className={`px-4  text-gray-800 font-semibold py-2 rounded-t ${
            activeTab === 'first' ? 'bg-white  dark:text-stroke-o3 dark:bg-large-blue border-t border-r border-l -mb-px' : 'dark:bg-dark-slate dark:text-blur-gray'
          }`}
        >
          <button onClick={() => handleTabClick('first')}>Tất cả</button>
        </li>
        <li
          className={`px-4 text-gray-800  font-semibold py-2 rounded-t ${
            activeTab === 'second' ? 'bg-white  dark:text-stroke-o3 dark:bg-large-blue border-t border-r border-l -mb-px' : 'dark:bg-dark-slate  dark:text-blur-gray'
          }`}
        >
          <button onClick={() => handleTabClick('second')}>{`${home.name} sân nhà`}</button>
        </li>
        <li
          className={`px-4 text-gray-800 font-semibold py-2 rounded-t ${
            activeTab === 'third' ? 'bg-white  dark:text-stroke-o3 dark:bg-large-blue border-t border-r border-l -mb-px' : 'dark:bg-dark-slate  dark:text-blur-gray'
          }`}
        >
          <button onClick={() => handleTabClick('third')}>{`${away.name} sân nhà`}</button>
        </li>
      </ul>

      <div id="tab-contents">
        <HeaderTopRecentMatches/>
        <div className={`${activeTab === 'first' ? '' : 'hidden'}`}>
          {data.map((item, index) => <H2HItem match={item} />)}
        </div>
        <div className={`${activeTab === 'second' ? '' : 'hidden'}`}>
        {data.filter((e) => e.homeTeamId === home.id).map((item, index) => <H2HItem match={item} />)}
          
        </div>
        <div className={`${activeTab === 'third' ? '' : 'hidden'}`}>
          {data.filter((e) => e.homeTeamId === away.id).map((item, index) => <H2HItem match={item} />)}
        </div>
      </div>
    </div>
  );
}

export default React.memo(TabPanel);
